export function truncateWithComma(num: number, digits: number): string {
  const factor = Math.pow(10, digits);
  const truncated = Math.floor(num * factor) / factor;

  return truncated.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}